<template>
    <div
        :class="[
            shadow ?? '',
            shape === 'round' ? 'rounded-full' : 'rounded-6',
            sizeClass,
            border ? 'border border-white' : ''
            ]"
        class="flex-none overflow-hidden"
    >
        <div
            class="flex justify-center items-center shadow-inner flex-none bg-cover bg-no-repeat bg-center w-full h-full"
            :style="[image ? { backgroundImage: 'url(' + image + ')' } : { backgroundColor: color }]"
        >
            <span
                v-if="!image"
                class="text-white tracking-wide uppercase font-semibold"
                :class="fontSizeClass"
            >
                <slot></slot>
            </span>
        </div>
    </div>
</template>

<script>
import styles from '../../../../../../styles.config';

export default {
    props: {
        size: {
            type: String,
            default: 'medium',
            validator: value => ['small', 'medium', 'large'].includes(value),
        },
        color: {
            type: String,
            default: styles.colors.primary.DEFAULT,
        },
        shadow: String,
        border: Boolean,
        image: String,
        shape: {
            type: String,
            default: 'round',
            validator: value => ['round', 'square'].includes(value),
        }
    },
    data() {
        return {
            sizes: {
                small: 'w-36 h-36',
                medium: 'w-52 h-52',
                large: 'w-100 h-100',
            },
            fontSizes: {
                small: 'text-body-sm',
                medium: 'text-body',
                large: 'text-big',
            }
        }
    },
    computed: {
        sizeClass() {
            return this.sizes[this.size];
        },
        fontSizeClass() {
            return this.fontSizes[this.size];
        }
    },
}
</script>
